import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { catchError, map, of } from 'rxjs';
import { AuthState } from '../../features/auth/auth.state';
import { AuthService } from './auth.service';

/**
 * Guard cookie-based:
 * - If we already know the user is authenticated -> allow
 * - If we know the user is anonymous -> redirect to login
 * - If status is unknown -> validate via /authentication/session
 */
export const authGuard: CanMatchFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const store = inject(Store);
    const ngxStatus = store.selectSnapshot(AuthState.sessionStatus);

    if (auth.status === 'authenticated' || ngxStatus === 'authenticated') {
        return true;
    }
    if (auth.status === 'anonymous' || ngxStatus === 'anonymous') {
        return router.createUrlTree(['/auth/login'], {
            queryParams: { returnUrl: router.url },
        });
    }

    // unknown -> validate real session via cookie (401 => login, no session-expired modal)
    return auth.session().pipe(
        map(() => true),
        catchError(() =>
            of<UrlTree>(
                router.createUrlTree(['/auth/login'], {
                    queryParams: { returnUrl: router.url },
                })
            )
        )
    );
};
